import { UseFormReturn } from 'react-hook-form';

import { ContractData } from '@shared/types/contract-data';
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@web/components/ui/table';
import { PriceBreakdown } from './total-price-breakdown';

export function ContractSummaryView({
  form,
}: {
  form: UseFormReturn<ContractData>;
}) {
  const { firstName, lastName } = form.getValues();

  return (
    <div
      className="height-full space-y-4"
      style={{ height: '65dvh', overflow: 'auto', scrollbarWidth: 'none' }}
    >
      <p>
        Please, carefully review the contract for{' '}
        <strong>
          {firstName} {lastName}
        </strong>{' '}
        before submitting.
      </p>

      <div className="mt-4 grid w-auto grid-cols-2 gap-8 rounded-md p-6 shadow-md">
        <div>
          <strong>First Name:</strong> {form.getValues('firstName')}
        </div>
        <div>
          <strong>Last Name:</strong> {form.getValues('lastName')}
        </div>
        <div>
          <strong>Email:</strong> {form.getValues('email')}
        </div>
        <div>
          <strong>Phone:</strong>
          {form.getValues('phoneNumber')
            ? form.getValues('phoneNumber')
            : 'N/A'}
        </div>
      </div>

      <div className="w-small mt-4 rounded-md p-6 shadow-md">
        <strong>Surgeon:</strong> {form.getValues('surgeonDisplayName')}
      </div>

      <div className="flex w-full justify-between">
        <div
          className="rounded-md p-6 shadow-md"
          style={{ width: '45%', minWidth: '300px' }}
        >
          <Table>
            <TableHeader>
              <TableRow>
                <TableCell className="font-bold">Procedures</TableCell>
              </TableRow>
            </TableHeader>

            <TableBody>
              {form.watch('procedures').map((procedure) => (
                <TableRow key={procedure.id}>
                  <TableCell>{procedure.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <div
          className="rounded-md p-6 shadow-md"
          style={{ width: '45%', minWidth: '300px' }}
        >
          <Table>
            <TableHeader>
              <TableRow>
                <TableCell className="font-bold">Products</TableCell>
              </TableRow>
            </TableHeader>

            <TableBody>
              {form.watch('products').map((procedure) => (
                <TableRow key={procedure.id}>
                  <TableCell>{procedure.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
      <div className="mt-10 flex w-full justify-end">
        <PriceBreakdown
          subTotal={form.getValues('subTotal')}
          initialDiscount={+form.getValues('discount')}
          isEditable={false}
        />
      </div>
    </div>
  );
}
